/**
 * The name a student last typed on this device, so the next link opens with it filled in and she
 * only presses Start. The only place that touches this key. Storage can be off (private mode):
 * then she types it, as before.
 */
const KEY = 'tt-learner-name'

export function readLastName(): string {
	try {
		return localStorage.getItem(KEY) ?? ''
	} catch {
		return ''
	}
}

export function saveLastName(name: string) {
	try {
		localStorage.setItem(KEY, name)
	} catch {}
}

/** "Not you?" was pressed in this page load: the device is being passed between students. */
let passedOn = false

/**
 * Whether the student who just typed `typed` is not the one this device held (`previous`, read
 * before she typed): a shared tablet. Only what this page load and the stored name can show.
 */
export const deviceIsShared = (previous: string, typed: string): boolean =>
	passedOn || (previous !== '' && previous.trim().toLowerCase() !== typed.trim().toLowerCase())

/** "Not you?": the next student on a shared device must not meet her name already typed in. */
export function forgetLastName() {
	passedOn = true
	try {
		localStorage.removeItem(KEY)
	} catch {}
}
